import React, {Fragment} from 'react';
import {Input, FormFeedback, FormText} from 'reactstrap';

const RenderTextField = ({ input, meta: { touched, error, warning }, ...custom }) => (
  <Fragment>
      <Input {...(touched ? { valid: !error } : {})} {...input} {...custom} />
      {error && <FormFeedback>{error}</FormFeedback>}
      {!error && warning && <FormText>{warning}</FormText>}
  </Fragment>
);

const RenderRadioField = ({ value, input, ...custom }) => (
  <Input type="radio" checked={value === input.value} {...input} {...custom} />
);

const RenderCheckbox = ({ input: { value, onChange } }) => (
  <Input type="checkbox" checked={!!value} onChange={onChange} />
);

const RenderSelectField = ({ input, meta: { touched, error }, children, ...custom }) => (
  <Input type="select" {...(touched ? { valid: !error } : {})} {...input} {...custom}>
      {children}
  </Input>
);

export const renderField = props => {
  console.log(props);
  switch(props.type){
    case 'radio':
      return (
        <RenderRadioField {...props} />
      );
    case 'checkbox':
      return (
        <RenderCheckbox {...props} />
      );
    case 'select':
      return (
        <RenderSelectField {...props} />
      );
    default:
      return (
        <RenderTextField {...props} />
      );
  }
};



// WEBPACK FOOTER //
// ./src/components/fields/renderField.js